import './index.css';

/**
 * apps/kreate-love-app/src/main.tsx
 * Kreate.love umbrella landing app entry point.
 *
 * Intentionally minimal: no AuthProvider, no QueryClient, no Supabase —
 * this app is a public marketing surface that links out to katalag.com,
 * kloutsale.com and kloutforce.com.
 */

if (typeof document !== 'undefined') {
  // ThemeProvider will set data-theme on <html>; we use the kloutforce
  // enum slot for compatibility, then LandingShell scopes data-theme="kreate"
  // onto its subtree so the orange landing-accent tokens take over.
  document.documentElement.setAttribute('data-theme', 'kreate');
}

import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@bright-web-skeleton/ui';
import { LovableProvider, initTagger } from '@integrations/lovable';

import router from './app/router';

if (typeof window !== 'undefined') {
  initTagger();
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="kloutforce">
      <LovableProvider>
        <RouterProvider router={router} />
      </LovableProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
